import axios from 'axios';
import { generateURL } from './helper';
import { session } from '../Service/APIService';

const URL = generateURL();

const axiosClient = axios.create({
  baseURL: `${URL}/`,
  timeout: 600000,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});

// Add a request interceptor to include the Authorization header
axiosClient.interceptors.request.use(
  (config) => {
    let userObj = null;
    try {
      userObj = session.user();
    } catch (err) {
      console.log('Failed to parse UserInfo data', err);
    }

    if (userObj) {
      config.headers.Authorization = `Bearer ${userObj.token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosClient;
